<template>
  <div class="mpm-video-container">
    <!-- 视频缩略图 -->
    <div class="video-thumbnail" :style="{ width: width + 'px', height: height + 'px' }" @click="previewVideo">
      <video
        :src="formattedUrl"
        :width="width"
        :height="height"
        muted
        @error="handleVideoError"
        @loadstart="handleVideoLoadStart"
      >
        您的浏览器不支持视频播放
      </video>
      <div class="video-play-icon">
        <a-icon type="play-circle" />
      </div>
    </div>

    <!-- 视频预览模态框 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="closePreview" :width="720" centered>
      <div class="video-preview-modal">
        <video :src="formattedUrl" controls autoplay style="width: 100%; max-height: 60vh">
          您的浏览器不支持视频播放
        </video>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { UPLOAD_CDN_HOST } from '@/config/env'

  export default {
    name: 'MpmVideo',
    props: {
      // 视频URL
      url: {
        type: String,
        required: true,
      },
      // 缩略图宽度
      width: {
        type: [Number, String],
        default: 36,
      },
      // 缩略图高度
      height: {
        type: [Number, String],
        default: 36,
      },
      // 是否显示预览功能
      showPreview: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        previewVisible: false,
        baseUrl: UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV],
      }
    },
    computed: {
      // 格式化后的URL
      formattedUrl() {
        return this.formatImageUrl(this.url)
      },
    },
    methods: {
      // 格式化图片/视频URL
      formatImageUrl(url) {
        // 检查是否是完整的URL
        if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
          return url
        }

        // 使用环境变量中的CDN地址
        const fullUrl = this.baseUrl + url
        console.log('视频URL:', fullUrl) // 调试信息
        return fullUrl
      },

      // 视频加载错误处理
      handleVideoError(event) {
        console.error('视频加载失败:', event.target.src)
        console.error('错误详情:', event.target.error)
        this.$emit('error', {
          src: event.target.src,
          error: event.target.error,
        })
      },

      // 视频开始加载
      handleVideoLoadStart(event) {
        console.log('视频开始加载:', event.target.src)
        this.$emit('loadstart', event.target.src)
      },

      // 预览视频
      previewVideo() {
        if (this.showPreview) {
          this.previewVisible = true
          this.$emit('preview', this.url)
        }
      },

      // 关闭预览
      closePreview() {
        this.previewVisible = false
        this.$emit('preview-close')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mpm-video-container {
    .video-thumbnail {
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      border: 1px solid #e8e8e8;

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }

      .video-play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
        pointer-events: none;
      }

      &:hover {
        .video-play-icon {
          color: #1890ff;
        }
      }
    }

    .video-preview-modal {
      text-align: center;

      video {
        border-radius: 4px;
      }
    }
  }
</style>
